import { gql } from '@apollo/client';

export const ResponseLabelFields = gql`
  fragment ResponseLabelFields on Response {
    labelsConnection {
      edges {
        properties {
          condition
        }
        node {
          value
        }
      }
    }
  }
`;
